import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: the Transcription tab and speaker names. Started from the
 * lesson page in a new tab; never auto-started. Works best on a report made
 * from interaction audio, which is the only kind with speakers.
 */
const tour: TutorialDefinition = {
  id: "transcription-and-speakers",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Transcription",
  description: "Follow the audio, fix a word, and name the speakers.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "transcription-and-speakers",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report from audio",
      content: "Click a report made from a recording. One from interaction audio shows the speakers.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorTabTranscription"),
      waitFor: sel("editorTabTranscription"),
      waitTimeoutMs: 10000,
      title: "The Transcription tab",
      content: "Click it to see every line of the transcript.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("editorTabTranscription"), event: "click" },
      hint: "Click Transcription",
      spotlightClicks: true,
    },
    {
      target: sel("transcriptFollow"),
      waitFor: sel("transcriptFollow"),
      title: "Follow audio",
      content:
        "Turn this on and the current line highlights as the recording plays. Click any line to play from there.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("transcriptSegment"),
      waitFor: sel("transcriptSegment"),
      title: "Fix a line",
      content:
        "Hover a line and open its menu (the three dots) to Edit Transcription, Merge with Previous or Next, Split Segment, or Delete Segment.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("transcriptSpeaker"),
      waitFor: sel("transcriptSpeaker"),
      title: "Name the speakers",
      content:
        "Click a speaker's name, then the pencil beside it to open Edit Speaker Name. Do this before you regenerate the narrative.",
      disableBeacon: true,
      placement: "bottom",
    },
  ],
};

export default tour;
